module.exports = __webpack_public_path__ + "static/media/gaoxiaopan.5e2c14f3.png";